var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeneye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8211 6.74688C18.7937 6.68516 18.132 5.21719 16.6609 3.74609C14.7008 1.78594 12.225 0.75 9.49999 0.75C6.77499 0.75 4.29921 1.78594 2.33905 3.74609C0.867961 5.21719 0.203118 6.6875 0.178899 6.74688C0.143362 6.82681 0.125 6.91331 0.125 7.00078C0.125 7.08826 0.143362 7.17476 0.178899 7.25469C0.206243 7.31641 0.867961 8.78359 2.33905 10.2547C4.29921 12.2141 6.77499 13.25 9.49999 13.25C12.225 13.25 14.7008 12.2141 16.6609 10.2547C18.132 8.78359 18.7937 7.31641 18.8211 7.25469C18.8566 7.17476 18.875 7.08826 18.875 7.00078C18.875 6.91331 18.8566 6.82681 18.8211 6.74688ZM9.49999 10.125C8.88193 10.125 8.27774 9.94172 7.76383 9.59834C7.24993 9.25496 6.84939 8.7669 6.61287 8.19589C6.37634 7.62487 6.31446 6.99653 6.43504 6.39034C6.55562 5.78415 6.85324 5.22733 7.29028 4.79029C7.72732 4.35325 8.28414 4.05562 8.89033 3.93505C9.49652 3.81447 10.1249 3.87635 10.6959 4.11288C11.2669 4.3494 11.755 4.74994 12.0983 5.26384C12.4417 5.77775 12.625 6.38193 12.625 7C12.625 7.8288 12.2958 8.62366 11.7097 9.20971C11.1236 9.79576 10.3288 10.125 9.49999 10.125Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeneye);
export default __webpack_public_path__ + "static/media/Openeye.fb26aa1a47484a9361e9fb4ac182870b.svg";
export { ForwardRef as ReactComponent };